import axios from "axios";
import { urlBaseAccreditation } from './../../config/index';
import UserModel from "../../../models/UserModel";

export default async function setEventUserApi(
  token = '',
  eventId = '',
  user = UserModel(),
) {
  try {
    let _profile = getProfileString(user);

    const _options = {
      url: `${urlBaseAccreditation}/mobileUser/createMobileUser`,
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `bearer ${token}`
      },
      data: {
        name: user.Nome ? user.Nome.trim() : user.Nome,
        login: user.Login ? user.Login.trim() : user.Login,
        password: user.Senha ? user.Senha.trim() : user.Senha,
        eventId: parseInt(eventId),
        email: user.Email ? user.Email.trim() : user.Email,
        profile: _profile,
      }
    };
    let _data = await axios(_options);

    if (!_data.data.success) {
      throw new Error(_data.data.message);
    }

    let _return = { ...user };
    _return.ID = _data.data.data.id.toString();
    _return.ContratoID = _data.data.data.contractId.toString();
    return _return;
  } catch (error) {
    console.log('Error setEventUserApi', error);
    throw error;
  }

  function getProfileString(user = UserModel()) {
    try {
      let _object = {
        profile: user.Perfil || 'admin',
        scheduleId: user.PerfilProgramacao || '',
      }
      let _return = JSON.stringify(_object);
      return _return;
    } catch (error) {
      console.log('Error getProfileString');
    }
  }
}
